import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'

import CloseIcon from '../assets/images/common/close-icon.svg'
import LeftBlack from '../assets/images/common/left-icon.svg'
import LeftWhite from '../assets/images/common/left-white.svg'
import RightBlack from '../assets/images/common/right-icon.svg'
import RightWhite from '../assets/images/common/right-white.svg'
import DownIcon from '../assets/images/common/ico_down.svg'
import { getAnniversaryList } from 'apis/anniversary'
import { CHAT_URL } from 'views/Main'
import { jwtTokenState } from 'stores/jwtTokenState'
import { useRecoilValue } from 'recoil'

function MainPopup({ setModalOpen, chatWindowRef, dataRef }) {
  const jwtToken = useRecoilValue(jwtTokenState)
  const [isLockedPopup, setIsLockedPopup] = useState(true)
  const closeModal = () => {
    setModalOpen(false)
  }
  const closeModalOneDay = () => {
    const today = new Date()
    const oneDayLater = new Date(today.getTime() + 24 * 60 * 60 * 1000)
    localStorage.setItem('popupClosedDate', oneDayLater.toISOString())
    setModalOpen(false)
  }
  useEffect(() => {
    const popupClosedDate = localStorage.getItem('popupClosedDate')
    if (popupClosedDate) {
      const closedDate = new Date(popupClosedDate)
      const now = new Date()
      if (closedDate < now) {
        setIsLockedPopup(false)
      }
    } else {
      setIsLockedPopup(false)
    }
  }, [])
  if (isLockedPopup) return null
  return (
    <div className='z-[999] w-full h-full bg-default-black bg-opacity-70 fixed top-0 left-0 flex justify-center items-center'>
      <div className='w-[600px] relative'>
        <div className=' pb-[42px] h-[calc(100vw)] sm:h-[90%] overflow-auto'>
          <button
            onClick={() => {
              dataRef.current = null
              chatWindowRef.current = window.open(CHAT_URL + '?token=' + jwtToken, '_blank')
              chatWindowRef.current.opener = window
              // closeModal()
            }}
            className=' aspect-square w-full'
          >
            <div
              className='w-full h-full bg-cover bg-center bg-no-repeat'
              style={{
                backgroundImage: 'url(' + require('../assets/images/popup/popup_main.png') + ')',
              }}
            ></div>
            {/* <img src={require('../assets/images/popup/popup_main.png')} alt='마주온 톡톡 팝업' /> */}
          </button>
        </div>
        <div className='h-48 flex absolute bottom-0 w-full left-0 justify-between items-center  bg-default-white'>
          <button
            type='button'
            onClick={closeModalOneDay}
            className='flex items-center h-full justify-center flex-1 hover:bg-gray-100 py-10 border border-gray-500'
          >
            <p className='text-[14px] line-clamp-1 text-default-header'>오늘 하루 보지 않기</p>
          </button>
          <button
            type='button'
            className='flex items-center h-full justify-center flex-1 hover:bg-gray-100 py-10 border border-gray-500'
            onClick={closeModal}
          >
            <p className='text-[14px] line-clamp-1 text-default-header'>닫기</p>
          </button>
        </div>
      </div>
    </div>
  )
}

function Gasang({ setModalOpen }) {
  const closeModal = () => {
    setModalOpen(false)
  }
  return (
    <div className='z-[999] w-full h-full bg-default-black bg-opacity-70 fixed top-0 left-0 flex justify-center items-center '>
      <div className='w-[740px] sm:scale-100 scale-50 px-[15px] bg-default-white h-[120%] sm:h-[80%]'>
        <div className='flex justify-between px-[15px] h-60 items-center'>
          <p className='text-[18px] font-[700] text-default-black'>가상누리터</p>
          <button type='button' onClick={closeModal}>
            <img src={CloseIcon} alt='' />
          </button>
        </div>
        <div className='py-20 h-[calc(100%-60px)] overflow-auto'>
          <div
            className='px-[15px] pt-20 pb-[90px] bg-cover bg-center bg-no-repeat flex flex-col w-full items-center justify-center'
            style={{
              backgroundImage:
                'url(' + require('../assets/images/popup/gasang-background.png') + ')',
            }}
          >
            <p className='text-[26px] font-[700] text-default-black py-30 text-center'>
              충남형 가상누리터(메타버스) 플랫폼{' '}
              <span className='text-[#ef540f]'>주소 및 설치 안내</span>
            </p>
            <div className='flex items-center justify-center pb-20'>
              <div className='flex items-center justify-center  text-[16px]'>
                <div className='w-[30%] flex justify-center flex-col'>
                  <p className='bg-[#1b286b] text-default-white h-40 text-center flex items-center justify-center'>
                    플랫폼
                  </p>
                  <div className='flex flex-col'>
                    <p className='flex items-center justify-center text-center border-solid border-[#b0c3d8] border-r-[1px] h-[56px] border-b-[1px]'>
                      젭<br />
                      (Zep)
                    </p>
                    <div className='flex items-center justify-center'>
                      <p className='flex items-center justify-center w-1/2 border-solid border-[#b0c3d8] border-b-[1px] h-[392px]'>
                        인게이지
                        <br />
                        (Engage)
                      </p>
                      <div className='flex flex-col items-center justify-center w-1/2'>
                        <p className='text-center border-solid border-[#b0c3d8] border-b-[1px] w-full p-10 border-x-[1px] h-[56px] flex justify-center items-center'>
                          PC 설치
                        </p>
                        <p className='text-center border-solid border-[#b0c3d8] border-b-[1px] w-full p-10 border-x-[1px] h-[168px] flex justify-center items-center'>
                          앱<br />
                          (Android)
                        </p>
                        <p className='border-solid border-[#b0c3d8] w-full text-center p-10 border-x-[1px] h-[168px] flex justify-center items-center border-b-[1px]'>
                          앱<br />
                          (IOS)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='min-w-[340px] flex justify-center flex-col '>
                  <p className='bg-[#1b286b] text-default-white h-40 text-center flex items-center justify-center'>
                    주소(링크)
                  </p>
                  <Link
                    to='https://zep.us/play/DwM942'
                    target='_blank'
                    className='min-w-[340px] flex justify-center px-10 py-16 border-r-[1px] border-solid border-[#b0c3d8] h-[56px] border-b-[1px]'
                  >
                    <p>https://zep.us/play/DwM942</p>
                  </Link>
                  <Link
                    to='https://engagevr.io/download/'
                    target='_blank'
                    className='min-w-[340px] text-center border-r-[1px] border-solid border-[#b0c3d8] flex items-center justify-center h-[56px] border-b-[1px]'
                  >
                    <p>https://engagevr.io/download/</p>
                  </Link>
                  <Link
                    to='https://play.google.com/store/apps/details?id=com.ivre.engage&hl=ko'
                    target='_blank'
                    className='min-w-[340px] text-center border-r-[1px] border-solid border-[#b0c3d8] flex items-center justify-center h-[168px] border-b-[1px]'
                  >
                    <p>https://play.google.com/store/apps/details?id=com.ivre.engage&hl=ko</p>
                  </Link>
                  <Link
                    to='https://apps.apple.com/us/app/engage-communicate-teach-learn/id1532036164'
                    target='_blank'
                    className='min-w-[340px] text-center border-r-[1px] border-solid border-[#b0c3d8] flex items-center justify-center h-[168px] border-b-[1px]'
                  >
                    <p>https://apps.apple.com/us/app/engage-communicate-teach-learn/id1532036164</p>
                  </Link>
                </div>
                <div className='min-w-[156px] flex justify-center flex-col'>
                  <p className='bg-[#1b286b] text-default-white h-40 text-center flex items-center justify-center'>
                    비고(QR코드)
                  </p>
                  <div className='w-full h-[56px] border-b-[1px] border-solid border-[#b0c3d8]' />
                  <p className='min-w-[156px] text-center h-[56px] flex items-center justify-center border-b-[1px] border-solid border-[#b0c3d8]'>
                    ENGAGE_Installer
                  </p>
                  <img
                    src={require('../assets/images/popup/gasang-qr1.png')}
                    className='min-w-[156px] flex justify-center h-[168px] border-b-[1px] border-solid border-[#b0c3d8] p-10'
                    alt=''
                  />
                  <img
                    src={require('../assets/images/popup/gasang-qr2.png')}
                    className='min-w-[156px] flex justify-center h-[168px] border-b-[1px] border-solid border-[#b0c3d8] p-10'
                    alt=''
                  />
                </div>
              </div>
            </div>
            <button className='flex items-center h-48 justify-center px-40 bg-[#1b286b] text-[16px] text-default-white rounded-[5px] max-w-[220px] gap-10'>
              <p className='flex shrink-0'>설치 파일 다운로드</p>
              <img src={require('../assets/images/intro/downloadIcon.png')} alt='' />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

function GreenFootPrint({ setModalOpen }) {
  const closeModal = () => {
    setModalOpen(false)
  }
  return (
    <div className='z-[999] w-full h-full bg-default-black bg-opacity-70 fixed top-0 left-0 flex justify-center items-center'>
      <div className='w-[740px] sm:scale-100 scale-50 px-[15px] bg-default-white h-[120%] sm:h-[80%]'>
        <div className='flex justify-between px-[15px] h-60 items-center'>
          <p className='text-[18px] font-[700] text-default-black'>초록발자국</p>
          <button type='button' onClick={closeModal}>
            <img src={CloseIcon} alt='' />
          </button>
        </div>
        <div className='py-20 h-[calc(100%-60px)] overflow-auto'>
          <div
            className='px-[15px] py-20 bg-cover bg-center bg-no-repeat flex flex-col w-full pb-[100px]'
            style={{
              backgroundImage:
                'url(' + require('../assets/images/popup/greenfootprint-background.png') + ')',
            }}
          >
            <p className='text-[26px] font-[700] text-default-black py-30 text-center'>
              초록발자국 앱 <span className='text-[#2b600a]'>주소 및 설치 안내</span>
            </p>
            <div className='h-[45px] bg-[#40980a] text-default-white font-[700] text-center flex items-center justify-center border-y-[1px] border-solid border-[#2b600a]'>
              <p className='w-full'>운영체제</p>
              <p className='min-w-[340px]'>주소(링크)</p>
              <p className='min-w-[194px]'>QR코드</p>
            </div>
            <div className='flex items-center justify-center border-b-[1px] border-solid border-[#b0c3d8] h-[206px] bg-default-white2'>
              <p className='w-full text-center border-r-[1px] border-solid border-[#b0c3d8] h-full flex items-center justify-center'>
                앱<br />
                (Android)
              </p>
              <Link
                to='https://play.google.com/store/apps/details?id=com.Dcarrick.GreenFootPrint'
                target='_blank'
                className='min-w-[340px] text-center border-r-[1px] border-solid border-[#b0c3d8] h-full flex items-center justify-center'
              >
                https://play.google.com/store/apps/details?id=com.Dcarrick.GreenFootPrint
              </Link>
              <img
                src={require('../assets/images/popup/greenfootprint-qr1.png')}
                alt=''
                className='min-w-[194px] p-10 '
              />
            </div>
            <div className='flex items-center justify-center border-b-[1px] border-solid border-[#b0c3d8] h-[206px] bg-default-white2'>
              <p className='w-full text-center border-r-[1px] border-solid border-[#b0c3d8] h-full flex items-center justify-center'>
                앱<br />
                (IOS)
              </p>
              <Link
                href='https://apps.apple.com/kr/app/%EC%B4%88%EB%A1%9D%EB%B0%9C%EC%9E%90%EA%B5%AD/id1582136793'
                target='_blank'
                className='min-w-[340px] text-center border-r-[1px] border-solid border-[#b0c3d8] h-full flex items-center justify-center px-10'
              >
                <p className='w-full object-fit'>
                  https://apps.apple.com/kr/app/%EC%B4 %88%EB%A1%9D%EB%B0%9C%EC%9E
                  %90%EA%B5%AD/id1582136793
                </p>
              </Link>

              <img
                src={require('../assets/images/popup/greenfootprint-qr2.png')}
                alt=''
                className='min-w-[194px] p-10 '
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function Calendar({ setModalOpen }) {
  const dayList = ['일', '월', '화', '수', '목', '금', '토']

  const [groupedData, setGroupedData] = useState({})
  const getAnniversaryListApi = async () => {
    const getAnniversaryListRes = await getAnniversaryList()
    console.log(getAnniversaryListRes)
    if (getAnniversaryListRes.error) {
      return
    }
    if (getAnniversaryListRes.data && getAnniversaryListRes.data.anniversaries) {
      setGroupedData(
        getAnniversaryListRes.data.anniversaries.reduce((acc, item) => {
          const { year, month, day } = item
          if (!acc[year]) acc[year] = {}
          if (!acc[year][month]) acc[year][month] = {}
          if (!acc[year][month][day]) acc[year][month][day] = []

          acc[year][month][day].push(item)
          return acc
        }, {})
      )
    }
  }
  useEffect(() => {
    getAnniversaryListApi()
  }, [])
  const closeModal = () => {
    setModalOpen(false)
  }
  /* const groupedData = calendarData.reduce((acc, item) => {
    const { year, month, day } = item

    if (!acc[year]) acc[year] = {}
    if (!acc[year][month]) acc[year][month] = {}
    if (!acc[year][month][day]) acc[year][month][day] = []

    acc[year][month][day].push(item)
    return acc
  }, {}) */

  const [currentDate, setCurrentDate] = useState(new Date())

  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getMonth()
  // const today = currentDate.getDate()

  const todayDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
  }

  const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay() // 1일의 요일
  const emptyDays = Array(firstDayOfMonth).fill(null) // 1일 이전의 빈공간
  const lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDay()
  const lastDays = Array(6 - lastDayOfMonth).fill(null)
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate()

  const handlePrevMonth = () => {
    // 이전 달로 이동
    setCurrentDate(new Date(currentYear, currentMonth - 1, 1))
  }

  const handleNextMonth = () => {
    // 다음 달로 이동
    setCurrentDate(new Date(currentYear, currentMonth + 1, 1))
  }
  // const [clickedDate, setClickedDate] = useState({
  //   year: currentYear,
  //   month: currentMonth + 1,
  //   day: today < 10 ? `0${today}` : `${today}`,
  // })
  const [clickedDate, setClickedDate] = useState({
    year: '',
    month: '',
    day: '',
  })
  const getEvents = (year, month, day) => {
    return groupedData[year]?.[month]?.[day]
  }

  const [isPrevHovered, setIsPrevHovered] = useState(false)
  const [isNextHovered, setIsNextHovered] = useState(false)
  return (
    <div className='z-[999] w-full h-full bg-default-black bg-opacity-70 fixed top-0 left-0 flex justify-center items-center overflow-auto'>
      <div className='w-[740px] px-[15px] bg-default-white select-none'>
        <div className='flex justify-between px-[15px] h-60 items-center'>
          <p className='text-[18px] font-[700] text-default-black'>충남교육 달력</p>
          <button type='button' onClick={closeModal}>
            <img src={CloseIcon} alt='' />
          </button>
        </div>
        <div className='flex flex-col gap-[30px] h-[calc(90vh-60px)] pb-20 overflow-y-auto'>
          {/* year/month */}
          <div className='flex items-center justify-center gap-60'>
            <img
              onMouseEnter={() => setIsPrevHovered(true)}
              onMouseLeave={() => setIsPrevHovered(false)}
              onClick={handlePrevMonth}
              className='p-4 rounded-[50%] border-[1px] border-solid border-[#d6dde5] cursor-pointer hover:bg-[#eb6100]'
              src={isPrevHovered ? LeftWhite : LeftBlack}
              alt=''
            />
            <div className='text-[24px] text-default-header flex items-center gap-4'>
              <p className=' font-[300]'>{currentYear}년</p>
              <p className='font-[700]'>{currentMonth + 1}월</p>
            </div>
            <img
              onMouseEnter={() => setIsNextHovered(true)}
              onMouseLeave={() => setIsNextHovered(false)}
              onClick={handleNextMonth}
              className='p-4 rounded-[50%] border-[1px] border-solid border-[#d6dde5] cursor-pointer hover:bg-[#eb6100]'
              src={isNextHovered ? RightWhite : RightBlack}
              alt=''
            />
          </div>
          {/* calendar */}
          <div>
            <div className='grid grid-cols-7 border-t-[1px] border-x-[1px] border-solid border-t-[#004998] border-x-[#c4cad6]'>
              {dayList.map((day, index) => (
                <p
                  key={index}
                  className={`${
                    index === 0
                      ? 'text-[#c3342c]'
                      : index === 6
                      ? 'text-[#3a5ddc] border-r-0'
                      : 'text-default-header'
                  }
                  text-[11px] font-[300] py-16 text-center border-[#ebeef3] border-r-[1px] border-solid border-b-[1px]`}
                >
                  {day}
                </p>
              ))}
              {/* 1일 이전의 빈 공간 */}
              {emptyDays.map((_, index) => (
                <div
                  key={index}
                  className='border-[#ebeef3] min-h-80 border-r-[1px] border-solid border-b-[1px]'
                ></div>
              ))}

              {/* 날짜별 일정 */}
              {Array.from({ length: daysInMonth }).map((_, index) => {
                const day = index + 1
                const dayStr = day < 10 ? `0${day}` : `${day}`
                const events = groupedData[currentYear]?.[currentMonth + 1]?.[dayStr] || []
                const dayOfWeek = new Date(currentYear, currentMonth, day).getDay()

                return (
                  <div
                    key={index}
                    onClick={(e) =>
                      setClickedDate({ year: currentYear, month: currentMonth + 1, day: dayStr })
                    }
                    className={`${
                      currentMonth + 1 !== todayDate.month
                        ? 'border-[#ebeef3]'
                        : day === todayDate.day
                        ? 'border-[#0096ff] border-[1px]'
                        : 'border-[#ebeef3]'
                    }
                      ${dayOfWeek === 6 ? 'border-r-0' : 'border-r-[1px]'}
                      ${
                        currentMonth === clickedDate.month
                          ? 'bg-default-white'
                          : dayStr === clickedDate.day
                          ? 'bg-[#eb6100]'
                          : 'bg-default-white'
                      }
                       text-[11px] min-h-80 font-[300] border-solid border-b-[1px] hover:bg-[#eb6100] group`}
                  >
                    <p
                      className={`${
                        currentMonth === clickedDate.month
                          ? 'text-default-header'
                          : dayStr === clickedDate.day
                          ? 'text-default-white'
                          : dayOfWeek === 0
                          ? 'text-[#c3342c]'
                          : dayOfWeek === 6
                          ? 'text-[#3a5ddc]'
                          : currentMonth + 1 !== todayDate.month
                          ? 'text-default-header'
                          : day === todayDate.day
                          ? 'text-[#0096ff]'
                          : 'text-default-header'
                      }
                      text-[11px] font-[300] px-4 py-2 group-hover:text-default-white transition-all duration-300`}
                    >
                      {day}
                    </p>
                    {events.length > 0 ? (
                      <div>
                        {events.map((event, index) => (
                          <p
                            key={index}
                            className={`${
                              event.downloadUrl ? 'bg-[#ffb303]' : 'bg-[#a4d236]'
                            } text-default-white m-[1px] p-2`}
                          >
                            {event.name}
                          </p>
                        ))}
                      </div>
                    ) : null}
                  </div>
                )
              })}
              {/* 마지막날 이후의 빈공간 */}
              {lastDays.map((_, index) => (
                <div
                  key={index}
                  className='border-[#ebeef3] min-h-80 border-r-[1px] border-solid border-b-[1px]'
                ></div>
              ))}
            </div>
          </div>
          {/* schedule */}
          {clickedDate.year ? (
            <div className='flex flex-col bg-[#efefef] px-10 divide-[#ccc] divide-y-[1px] divide-dashed'>
              {getEvents(clickedDate.year, clickedDate.month, clickedDate.day)?.map(
                (item, index) => (
                  <div key={index} className='flex flex-col gap-10 py-10'>
                    <div className='flex items-center justify-between'>
                      <p className='text-[16px] text-default-black font-[700] text-start'>
                        {item.name}
                      </p>
                      {item.downloadUrl && (
                        <a
                          href={item.downloadUrl}
                          target='_blank'
                          rel='noreferrer'
                          download={item.name + '자료'}
                        >
                          <div className='text-[14px] w-fit text-[#545f80] font-bold border border-[#d6dbe4] flex items-center justify-center bg-default-white pl-10 pr-20 py-[3px] rounded-full'>
                            <img src={DownIcon} alt='자료 다운로드' className='w-24 h-24' />
                            <p>{item.name + '자료'}</p>
                          </div>
                        </a>
                      )}
                    </div>
                    <p className='text-[12px] font-[400] text-default-header text-center'>
                      {item.description}
                    </p>
                  </div>
                )
              ) || (
                <div className='text-[12px] font-[400] text-default-header text-center bg-[#efefef] py-40'>
                  등록된 일정이 없습니다.
                </div>
              )}
            </div>
          ) : (
            <div className='flex flex-col bg-[#efefef] px-10 divide-[#ccc] divide-y-[1px] divide-dashed'>
              {getEvents(todayDate.year, todayDate.month, todayDate.day)?.map((item, index) => (
                <div key={index} className='flex flex-col gap-10 py-10'>
                  <div className='flex items-center justify-between'>
                    <p className='text-[16px] text-default-black font-[700] text-start'>
                      {item.name}
                    </p>
                    {item.downloadUrl && (
                      <a
                        href={item.downloadUrl}
                        target='_blank'
                        rel='noreferrer'
                        download={item.name + '자료'}
                      >
                        <div className='text-[14px] w-fit text-[#545f80] font-bold border border-[#d6dbe4] flex items-center justify-center bg-default-white pl-10 pr-20 py-[3px] rounded-full'>
                          <img src={DownIcon} alt='자료 다운로드' className='w-24 h-24' />
                          <p>{item.name + '자료'}</p>
                        </div>
                      </a>
                    )}
                  </div>
                  <p className='text-[12px] font-[400] text-default-header text-center'>
                    {item.description}
                  </p>
                </div>
              )) || (
                <div className='text-[12px] font-[400] text-default-header text-center bg-[#efefef] py-40'>
                  등록된 일정이 없습니다.
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export { Gasang, GreenFootPrint, Calendar, MainPopup }
